import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import EtfList from '../etf_list.json';
const options = EtfList.map(etf =>
({
    value: etf.ticker,
    label: etf.ticker,
    name: etf.name,
    url: etf.url,
}));

const renderOption = (props, option) => (
    <Box component="li" sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
    }} {...props}>
        <Box sx={{ width: '100%' }}>{option.label}</Box>
        <Box sx={{ width: '100%', fontSize: 12 }}>{option.name}</Box>
    </Box>
);

const filterOptions = createFilterOptions({
    stringify: (option) => option.name + option.label,
});

const Search = ({parentCallback, index, defaultEtf}) => {
    return (
 
        <Autocomplete
            onChange={(event, newValue) => {
                parentCallback(newValue, index);
            }}
            // onChange={parentCallback(newValue)}
            id="combo-box-demo"
            options={options}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Ticker or Name" />}
            renderOption={renderOption}
            filterOptions={filterOptions}
            defaultValue={() => {
                var etf = options.find(op => op.value === defaultEtf);
                parentCallback(etf, index);
                return etf;
            }}
        />
    );
};

export default Search;